import Music5 from './Music5'
export default Music5
